"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.staff = staff;
exports.client = client;
exports.clientBeta = clientBeta;
exports.atendimentoClient = atendimentoClient;
exports.myPayOnboardingClient = myPayOnboardingClient;
exports.myPayOnboardingRefAccountant = myPayOnboardingRefAccountant;
exports.employer = employer;
exports.employee = employee;
exports.esalesCustomerCenter = esalesCustomerCenter;
exports.samba = samba;
exports.staffDocumentsBasic = staffDocumentsBasic;
exports.csAdmin = csAdmin;
exports.emergingAccounts = emergingAccounts;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

function staff(grants) {
  return (0, _includes.default)(grants).call(grants, 'staff');
}

function client(grants) {
  return (0, _includes.default)(grants).call(grants, 'client') && !staff(grants);
}

function clientBeta(grants, iacs) {
  return ((0, _includes.default)(grants).call(grants, 'client.beta') || (0, _includes.default)(iacs).call(iacs, 'ClientCenterVnext')) && client(grants);
}

function atendimentoClient(grants, env) {
  return (0, _includes.default)(grants).call(grants, 'client') && !staff(grants) && env.countryCode === 'BR';
}

function myPayOnboardingClient(grants) {
  return (0, _includes.default)(grants).call(grants, 'client.mypayonboarding') && !staff(grants);
}

function myPayOnboardingRefAccountant(grants) {
  return (0, _includes.default)(grants).call(grants, 'staff.mypayonboarding.refaccountant');
}

function employer(grants) {
  return (0, _includes.default)(grants).call(grants, 'samba.employer.center');
}

function employee(grants) {
  return (0, _includes.default)(grants).call(grants, 'samba.employee.center');
}

function esalesCustomerCenter(grants) {
  return (0, _includes.default)(grants).call(grants, 'samba.esales.customer.center');
}

function samba(grants) {
  return (0, _includes.default)(grants).call(grants, 'samba') && !myPayOnboardingClient(grants) && !employee(grants) && !employer(grants) && !esalesCustomerCenter(grants);
}

function staffDocumentsBasic(grants) {
  return (0, _includes.default)(grants).call(grants, 'staff.setup.firm') && (0, _includes.default)(grants).call(grants, 'staff.setup.clients');
}

function csAdmin(grants) {
  return (0, _includes.default)(grants).call(grants, 'csadmin');
}

function emergingAccounts(grants) {
  return (0, _includes.default)(grants).call(grants, 'emergingaccounts');
}
